import { alphaVar } from "@components/ui/colors";
import type { SvgIconComponent } from "@mui/icons-material";
import { Box } from "@mui/material";

import type { InvoiceIconName } from "../types/invoiceCustomStyle.types";
import type { InvoiceStyleTokens } from "../utils/createInvoiceStyleTokens";
import { getInvoiceIcon } from "../utils/invoiceIconRegistry";

interface InvoiceSectionIconProps {
  iconName?: InvoiceIconName;
  fallbackIcon: SvgIconComponent;
  styleTokens: InvoiceStyleTokens;
  size?: number;
}

export const InvoiceSectionIcon = ({ iconName = "default", fallbackIcon, styleTokens, size = 18 }: InvoiceSectionIconProps) => {
  const Icon = getInvoiceIcon(iconName, fallbackIcon);

  if (!Icon) {
    return null;
  }

  return (
    <Box
      component="span"
      sx={{
        width: size + 12,
        height: size + 12,
        flexShrink: 0,
        borderRadius: styleTokens.borders.radius.small,
        bgcolor: alphaVar(styleTokens.colors.icon, 0.08),
        color: styleTokens.colors.icon,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Icon
        sx={{
          display: "block",
          color: "inherit",
          fontSize: size,
        }}
      />
    </Box>
  );
};
